export interface ISetOfflineModeAction {
  type: 'CORE_SET_OFFLINE_MODE'
  isOffline: boolean
  // true if the user chose offline mode themselves. Only automatic offline mode
  // (caused by connection errors) is left again automatically once the server is reachable.
  manual: boolean
}

export const setOfflineMode = (isOffline: boolean, manual = false): ISetOfflineModeAction => ({
  type: 'CORE_SET_OFFLINE_MODE',
  isOffline,
  manual
})

// visitors of a shared link have no user: their page follows the company's design switch
export interface ISetVisitorDesignAction {
  type: 'CORE_SET_VISITOR_DESIGN'
  newDesign: boolean
}

export const setVisitorDesign = (newDesign: boolean): ISetVisitorDesignAction => ({
  type: 'CORE_SET_VISITOR_DESIGN',
  newDesign
})

export type OfflineActions = ISetOfflineModeAction | ISetVisitorDesignAction
